import { useState } from "react";
import { CreateSessionResponse, OzowEstimateQuoteResult } from "src/api";

export interface DepositState {
  amount: string;
  amountTouched: boolean;
  initiateDepositLoading: boolean;
  initiateDepositError: string | null;
  sessionData: CreateSessionResponse | null;
  ozowEstimateQuote: OzowEstimateQuoteResult | null;
  ozowEstimateQuoteLoading: boolean;
  ozowEstimateQuoteError: string | null;
}

export const useDepositState = () => {
  const [amount, setAmount] = useState<string>("");
  const [amountTouched, setAmountTouched] = useState(false);
  const [initiateDepositLoading, setInitiateDepositLoading] = useState(false);
  const [initiateDepositError, setInitiateDepositError] = useState<string | null>(null);
  const [sessionData, setSessionData] = useState<CreateSessionResponse | null>(null);
  const [ozowEstimateQuote, setOzowEstimateQuote] = useState<OzowEstimateQuoteResult | null>(null);
  const [ozowEstimateQuoteLoading, setOzowEstimateQuoteLoading] = useState(false);
  const [ozowEstimateQuoteError, setOzowEstimateQuoteError] = useState<string | null>(null);

  return {
    amount,
    setAmount,
    amountTouched,
    setAmountTouched,
    initiateDepositLoading,
    setInitiateDepositLoading,
    initiateDepositError,
    setInitiateDepositError,
    sessionData,
    setSessionData,
    ozowEstimateQuote,
    setOzowEstimateQuote,
    ozowEstimateQuoteLoading,
    setOzowEstimateQuoteLoading,
    ozowEstimateQuoteError,
    setOzowEstimateQuoteError,
  };
};
